import * as Stats from 'stats-js';

const stats = new Stats();
stats.setMode(0);
stats.domElement.style.position = 'absolute';
stats.domElement.style.left = '0px';
stats.domElement.style.top = '0px';

export default stats;


// WEBPACK FOOTER //
// ./src/stats.js